import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import it from './locales/it.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import es from './locales/es.json';

export const SUPPORTED_LANGUAGES = [
    { code: 'it', name: 'Italiano', flag: '🇮🇹', native: 'Italiano' },
    { code: 'en', name: 'English', flag: '🇬🇧', native: 'English' },
    { code: 'fr', name: 'Français', flag: '🇫🇷', native: 'Français' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪', native: 'Deutsch' },
    { code: 'es', name: 'Español', flag: '🇪🇸', native: 'Español' },
];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            it: { translation: it },
            en: { translation: en },
            fr: { translation: fr },
            de: { translation: de },
            es: { translation: es },
        },
        fallbackLng: 'it',
        supportedLngs: ['it', 'en', 'fr', 'de', 'es'],
        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            lookupLocalStorage: 'cantiereai_lang',
            caches: ['localStorage'],
        },
        react: {
            useSuspense: false,
        },
    });

// Sync backend on language change for logged-in users
i18n.on('languageChanged', async (lng) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
        await fetch(`${BACKEND_URL}/api/auth/me/language`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ language: lng }),
        });
    } catch (e) { /* silent */ }
    // Update <html lang="...">
    if (typeof document !== 'undefined') document.documentElement.lang = lng;
});

if (typeof document !== 'undefined') document.documentElement.lang = i18n.language || 'it';

export default i18n;
